<script>
import AdminLayout from '@layouts/admin-main'
import PolicyInfo from '@components/admin/withdraw-policy-info'
import { fetchPolicies, deletePolicy } from '@apis/admin/withdraw'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  page: {
    title: 'Admin::Market',
    meta: [{ name: 'description', content: 'Admin::Market' }],
  },
  components: {
    AdminLayout,
    PolicyInfo,
  },
  data() {
    return {
      policies: [],
      target_policy_seq: 0,
      show_policy_info: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadPolicies()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadPolicies() {
      const { data } = await fetchPolicies()

      this.policies = data
    },
    handleCreatePolicy() {
      this.show_policy_info = true
      this.target_policy_seq = null
    },
    handleUpdatePolicy({ seq }) {
      this.show_policy_info = true
      this.target_policy_seq = seq
    },
    handlePolicySubmit(seq) {
      this.init()
      this.target_policy_seq = seq
    },
    async handleDeletePolicy(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deletePolicy(seq)
        await this.loadPolicies()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    fromPairs,
  },
}
</script>

<template>
  <AdminLayout>
    <div :class="$style.adminLeftContent">
      <h3 :class="$style.xeAdmin">{{
        $t('withdraw_policy.policy_management')
      }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('withdraw_policy.inspection_priority') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('withdraw_policy.act_of_execution') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('withdraw_policy.title') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreatePolicy"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="policy in policies" :key="policy.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{
              policy.list_order
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{
              fromPairs(constants.withdraw.policy.action_type)[
                policy.action_type
              ]
            }}</td>
            <td :class="[$style.wide]">{{ policy.title }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdatePolicy(policy)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeletePolicy(policy.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!policies.length">
            <td :colspan="4" :class="$style.tCenter">{{
              $t('withdraw_policy.msg_no_registration_policy')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div :class="$style.adminRightExtra">
      <h3 :class="$style.xeAdmin">{{ $t('withdraw_policy.summary') }}</h3>
      <p>{{ $t('withdraw_policy.msg_establish_and_discard') }}</p>
      <p
        >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
        lacus lacus, mattis et ante et, placerat fringilla ex. Phasellus
        lobortis metus id nisl auctor, non auctor odio volutpat. Nullam rutrum
        urna ut diam venenatis tincidunt. Donec quis ullamcorper mauris.
        Praesent mi mauris, semper ac lectus eget, volutpat viverra sem. Mauris
        hendrerit magna sed eros blandit, pulvinar hendrerit metus ullamcorper.
        Vivamus laoreet mi eget mi tempor volutpat. Curabitur justo lorem,
        scelerisque quis dolor sit amet, vulputate imperdiet lacus. Class aptent
        taciti sociosqu ad litora torquent per conubia nostra, per inceptos
        himenaeos. Integer cursus, elit non congue rutrum, augue mi viverra
        nisl, eget facilisis urna augue sit amet elit. Integer metus odio,
        porttitor eget lacus vitae, cursus mollis libero. Mauris vitae nunc eget
        elit pulvinar pharetra. Nunc ut lobortis metus, ut suscipit arcu. Nulla
        convallis finibus libero. Quisque neque turpis, porttitor non porta sed,
        tincidunt in urna. Integer et rhoncus est.</p
      >
      <p
        >Interdum et malesuada fames ac ante ipsum primis in faucibus. Vivamus
        mattis dui in lacus varius imperdiet. Ut blandit vulputate ultricies.
        Sed tempor pharetra pretium. Pellentesque id erat ut nisl auctor lacinia
        vel eget quam. Nulla at diam viverra risus laoreet iaculis. Nulla
        facilisi. Donec a justo vestibulum, elementum eros quis, mollis nulla.
        Duis semper nisl libero, vitae consequat nulla cursus vel. Morbi
        ultrices metus pretium, mollis quam in, luctus mi. Fusce eget congue
        augue.</p
      >
      <p
        >Pellentesque rhoncus magna vel ante pretium porta nec et arcu. Nam sit
        amet est hendrerit, porttitor sapien ac, porttitor quam. Morbi mauris
        velit, imperdiet id velit eget, posuere pharetra dolor. Nullam mollis
        viverra nisl. Cras eget dignissim erat. Etiam vitae sapien est.
        Phasellus suscipit sapien sit amet diam suscipit pharetra. Nullam
        vestibulum ligula et magna fermentum vehicula. Aliquam bibendum arcu ac
        varius porttitor. In tristique lobortis felis, eget tincidunt ante
        sodales et. Etiam sit amet nulla vitae diam imperdiet cursus.
        Suspendisse interdum sed quam a condimentum. Maecenas eget magna
        scelerisque, ullamcorper eros at, hendrerit purus.</p
      >
    </div>
    <ElDialog
      :title="
        target_policy_seq
          ? $t('withdraw_policy.modification')
          : $t('withdraw_policy.registration')
      "
      :visible.sync="show_policy_info"
    >
      <PolicyInfo
        v-if="show_policy_info"
        :key="target_policy_seq"
        :policy_seq="target_policy_seq"
        @submit="handlePolicySubmit"
      ></PolicyInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
.adminRightExtra p {
  margin: 10px 0;
}
</style>
